import { Component, HostBinding, Input } from '@angular/core';
import { UXBlock } from '../../../core/models/ux-page';

import { AnalyticsService } from '../../../shared/services/analytics.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.scss']
})
export class BlockComponent {
  @HostBinding('class') get classes(): string {
    if (this.blocksCount <= 1) return 'col-md-12 col-sm-12'
    if (this.blocksCount === 2) return 'col-md-6 col-sm-6'
    if (this.blocksCount === 3) return 'col-md-4 col-sm-12'
    if (this.blocksCount === 4) return 'col-md-3 col-sm-6'
    if (this.blocksCount === 5) return 'col-md-4 col-sm-4 '
    if (this.blocksCount >= 6) return 'col-md-3 col-sm-6'
  }
  @Input() block: UXBlock
  @Input() type: 'default' | 'home' = 'default'
  @Input() blocksCount: Number = 0

  constructor(private analyticsSvc: AnalyticsService, private router: Router) {}

  onClick(): void {
    if (this.hasExternalLink) {
      window.open(this.block.externalLink, '_blank')
    } else if (this.hasLink) {
      this.analyticsSvc.event('click', { event_category: 'Homeblock', event_label: this.title })
      this.router.navigate([this.buttonLink])
    }
  }

  get hasImage(): boolean {
    return !! this.block.img
  }

  get image(): string {
    return this.block.img
  }

  get title(): string {
    return this.block.title
  }

  get hasSubtitle(): boolean {
    return !!this.block.subTitle
  }

  get subtitle(): string {
    return this.block.subTitle
  }

  get hasLink(): boolean {
    return !!this.block.link
  }

  get hasExternalLink(): boolean {
    return !!this.block.externalLink
  }

  get content(): string {
    return ''
  }

  get buttonLink(): string {
    return `/${this.block.link}`
  }

  get buttonText(): string {
    return this.block.buttonText
  }
}
